export type OAuthProvider = "google";

export const SUPPORTED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"] as const;
export const MAX_IMAGE_BYTES = 5 * 1024 * 1024;
export type SupportedImageType = (typeof SUPPORTED_IMAGE_TYPES)[number];

export interface ExistingContributionTarget {
  kind: "existing";
  itemId: string;
  name: string;
  imageUrl: string | null;
}

export interface CreatedContributionTarget {
  kind: "created";
  name: string;
  image: Blob;
}

export type ContributionTarget = ExistingContributionTarget | CreatedContributionTarget;

export interface LeaderboardItem {
  id: string;
  name: string;
  voteCount: number;
  rank: number;
  imageUrl: string | null;
}

export interface LeaderboardResponse {
  items: LeaderboardItem[];
  totalVotes: number;
  matchCount: number;
}

export interface ContributionItem {
  id: string;
  name: string;
  imageUrl: string | null;
}

export interface Contribution {
  item: ContributionItem;
  castAt: string;
}

export interface ContributionResponse {
  contribution: Contribution | null;
}

export type ContributionMutationOutcome = "created" | "replayed" | "already_cast";

export interface ContributionMutationResponse {
  outcome: ContributionMutationOutcome;
  contribution: Contribution;
}

export interface ApiErrorResponse {
  error: {
    code: string;
    message: string;
  };
}

const DATABASE_WHITESPACE_EDGES = /^[\u0009-\u000d\u0020\u0085\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000]+|[\u0009-\u000d\u0020\u0085\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000]+$/gu;

export function trimDatabaseWhitespace(value: string): string {
  return value.replace(DATABASE_WHITESPACE_EDGES, "");
}

export function bytesEqual(left: Uint8Array, right: Uint8Array): boolean {
  if (left.byteLength !== right.byteLength) return false;
  let difference = 0;
  for (let index = 0; index < left.byteLength; index += 1) {
    difference |= left[index]! ^ right[index]!;
  }
  return difference === 0;
}

export function bytesToHex(bytes: Uint8Array): string {
  let encoded = "";
  for (const byte of bytes) encoded += byte.toString(16).padStart(2, "0");
  return encoded;
}
